import ActionBtn from "components/buttons/ActionBtn";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Table } from "components/table/Table";
import EmptyState from "components/EmptyState/EmptyState";
import { useLocation, useNavigate } from "react-router-dom";
import { ModalTypes } from "configs/types";
import { useDispatch } from "react-redux";
import { openModal } from "store/modals/slice";
import { getThreads } from "services/support/threadsService";
import { ThreadListItem } from "./mockThreads";
import DataTableSkeleton from "components/global/Skeleton/TableSkeleton/DataTableSkeleton";
import { RefreshButton } from "components/buttons/RefreshButton";

const ThreadsList = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [list, setList] = useState<ThreadListItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchThreads = async () => {
    setIsLoading(true);
    try {
      const result = await getThreads();
      setList(result);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchThreads();
  }, []);

  const handleOpenEditModal = (id: number) => {
    navigate(
      `${location.pathname}?activeModal=${ModalTypes.threads}&entityId=${id}`,
    );
    dispatch(openModal({ activeModal: ModalTypes.threads }));
  };

  const handleOpenCreateModal = () => {
    navigate(`${location.pathname}?activeModal=${ModalTypes.threads}`);
    dispatch(openModal({ activeModal: ModalTypes.threads }));
  };

  const handleDelete = (id: number) => {
    setList((prev) => prev.filter((item) => item.id !== id));
  };

  const tableData = list.map(
    ({ id, userEmail, lang, type, title, updatedAt, assignee, status }) => ({
      id,
      userEmail,
      lang,
      type,
      title,
      updatedAt,
      assignee,
      status,
    }),
  );

  return (
    <div className="page-list-wrapper">
      <div className="page-list-header">
        <div className="page-list-header--box">
          <ActionBtn
            txt={t("newThreads")}
            handleClick={handleOpenCreateModal}
          />
        </div>
        <div className="page-list-header--box page-list-header--box--right">
          <RefreshButton
            position="right"
            disabled={true}
            isLoading={false}
            onClick={() => {}}
          />
        </div>
        <div className="page-list-header--box page-list-header--box-actions" />
      </div>

      {isLoading ? (
        <DataTableSkeleton columnsCount={10} rowsCount={6} />
      ) : list.length === 0 ? (
        <EmptyState message={t("noThreadsFound")} />
      ) : (
        <div className="game-table-wrap">
          <Table
            data={tableData as Array<ThreadListItem & { id: number }>}
            idField="id"
            onEdit={(id) => handleOpenEditModal(id)}
            onDelete={handleDelete}
            onAllSelect={() => {}}
          />
        </div>
      )}
    </div>
  );
};

export default ThreadsList;
